import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NotificationComponent } from './notification.component';
import { notificationRoutingModule } from './notification-routing.module';
import { NotificationListComponent } from './notification-list/notification-list.component';
import { NotificationFilterComponent } from './notification-filter/notification-filter.component';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatPaginatorModule} from '@angular/material/paginator';
import { NotificationService } from './services/notification.service';
import { LoaderService } from 'src/app/middleware/shared/loader/loader.service';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DayAgoPipe } from './day-ago-pipe';
@NgModule({
  declarations: [NotificationComponent, NotificationListComponent, NotificationFilterComponent,DayAgoPipe],
  imports: [
    CommonModule,
    notificationRoutingModule,
    MatCardModule,
    MatIconModule,
    MatInputModule,
    MatFormFieldModule,
    MatPaginatorModule,
    MatButtonModule
  ],
  providers: [
    NotificationService,
    LoaderService,
    { provide: MAT_DIALOG_DATA, useValue: {} },
    { provide: MatDialogRef, useValue: {} }      
  ],

})
export class NotificationModule { }
